export interface ComponentDialogAlertProperties {
    title: string;
    message: string;
    buttonText: string;
    type: ComponentDialogAlertType;
    stopProcess: boolean;
}

export enum ComponentDialogAlertType {
    Error = 0,
    Success = 1,
    Warning = 2,
    Feedback = 3
}